import cx from "classnames";
import React, { forwardRef } from "react";

const CLASS_ROOT = "container";

const Container = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...other }, ref) => {
  const classes = cx(CLASS_ROOT, className);

  return <div className={classes} ref={ref} {...other} />;
});

Container.displayName = "Container";

export { Container };
